module.exports = __webpack_public_path__ + "plane-classic-chrome.d94106d5b21ce702ca79.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/plane-classic-chrome.svg
// module id = ../../../../../src/assets/img/plane-classic-chrome.svg
// module chunks = main